import { useState, useEffect } from 'react'
import PageHeader from '../../components/common/PageHeader'
import DynamicTable from '../../components/common/DynamicTable';
import AdminFormModal from '../../components/modals/forms/AdminFormModal';
import { listAdmins, createAdmin, editAdmin, deleteAdmin, showPassCode } from '../../api/endpoints/admin';
import showSuccessAlert from '../../utils/swalAlerts/showSuccessAlert';
import showErrorAlert from '../../utils/swalAlerts/showErrorAlert';
import { showDeleteAlert } from '../../utils/swalAlerts/showDeleteAlert';

const List = () => {
  const [admin, setAdmin] = useState([]);
  const [search, setSearch] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [adminData, setAdminData] = useState([]);

  useEffect(()=>{
    async function fetchData() {
      const response  = await listAdmins();
      //console.log(response);
      if(response.status === 200){
        console.log(response.data.data);
        setAdminData(response.data.data);
      }else{
        // show alert something went wrong
      }
    }
    fetchData();  
  },[]);

  const adminColumns = [
    { header: "Name", accessor: "full_name",  render: (_, row) => `${row.first_name} ${row.last_name}` },
    { header: "Email", accessor: "email_id" },
    { header: "Mobile", accessor: "mobile" },
    { header: "Role", accessor: "role.name" },
    {
      header: "Status",
      accessor: "admin_status",
      render: (value) => (
        <span className={`badge ${value === 1 ? "bg-success" : "bg-danger"}`}>
          {value === 1 ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];

  const handleAdd = () => {
    setSelectedId(null);
    setModalVisible(true);
  };

  const handleEdit = (row) => {
    setSelectedId(row.admin_id);
    console.log(row.admin_id);
    setModalVisible(true);
  };

  const handlePasscode = (row) => {
    showDeleteAlert({
      title: 'Are you sure you want to view the password?',
      message: '',
      confirmButtonText: 'Yes, Show!',
      onConfirm: async () => {
        try {
          const response = await showPassCode(row.admin_id);
          console.log(response);
          if(response.status === 200){
            // send sucess 
            console.log(response.data);
            if(response.data.success){
              showSuccessAlert({
                title: "Password",
                message: atob(response.data.message),
                icon: "success",
                onBack: () => window.location.reload(),
              })
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Delete failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  }

  const handleDelete = (row) => {
    showDeleteAlert({
      title: 'Are you sure you want to delete this Admin?',
      message: 'This action is irreversible.',
      confirmButtonText: 'Yes, delete it!',
      onConfirm: async () => {
        try {
          const response = await deleteAdmin(row.admin_id);
          console.log(response);
          if(response.status === 200){
            // send sucess 
            console.log(response.data);
            if(response.data.success){

              showSuccessAlert({
                title: "Successful!",
                message: response.data.message,
                icon: "success",
                onBack: () => window.location.reload(),
              })
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Delete failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  }

  const handleSave = async (admin) => {
    let response = {};
    let swalmsg = "";
    if (admin.admin_id) {
      setAdmin((prev) =>
        prev.map((c) => (c.admin_id === admin.admin_id ? admin : c))
      );
      delete admin.email_id;
      response = await editAdmin(admin);
      swalmsg = 'The admin was successfully editted.';
    } else {
      setAdmin((prev) => [...prev, { ...admin, admin_id: Date.now().toString() }]);
      delete admin.admin_id;
      response = await createAdmin(admin);
      swalmsg = 'The admin was created successfully.';
    }
    if(response.status === 200){
        showSuccessAlert({
          title: "Successful!",
          message: swalmsg,
          icon: "success",
          onBack: () => window.location.reload(),
        })
      }else{
        showErrorAlert({
          title: "Oops...! Something went Wrong !",
          message: "Please try after sometime.",
          icon: "error",
        })
      }
    
  };
  return (
    <>
    <PageHeader  title="Admin List" breadcrumbs={[ {label: 'Administration'},{ label: 'Dummy for link', link: '/' }, {label: 'Admin List'}]}/>
    <DynamicTable
      data={adminData}
      columns={adminColumns}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      onPassCode={handlePasscode}
      onDeleteMultiple={() => console.log("Bulk delete")}
      //search={search}
      //onSearchChange={(e) => setSearch(e.target.value)}
    />

    <AdminFormModal
        show={modalVisible}
        onClose={() => setModalVisible(false)}
        onSave={handleSave}
        adminId={selectedId}
      />
    
    </>
  )
}

export default List